module.exports = __webpack_public_path__ + "9c5b45a620df869b636b41b51e2bb4af.pdf";